    import { Injectable } from '@angular/core';
    import { HttpClient, HttpHeaders } from '@angular/common/http';
    import { BehaviorSubject, Observable, of } from 'rxjs';
    import { catchError, tap } from 'rxjs/operators';
    import { Usuario } from '../_models/usuario/usuario';
    import { environment } from '../../environments/environment';
    import { UsuarioResponse } from '../_models/response/usuarioResponse';
    import { UpdatePasswordResponse } from '../_models/auth/updatePasswordResponse';
    import { UpdatePassword } from '../_models/auth/updatePassword';

    export const HTTP_OPTIONS = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Access-Control-Allow-Credentials' : 'true',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, DELETE, PUT, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
  })
};

    @Injectable({ providedIn: 'root' })
    export class UsuarioService {
      constructor(private http: HttpClient) { }

    getAll(usuario: Usuario): Observable<Usuario[]>{
      return this.http.post<Usuario[]>(`${environment.authorizedUrls.bsCobrancaUrl}/usuario/listarPorEmpresa`, {
        usuario
      });
    }

  addUsuario(usuario: Usuario): Observable<UsuarioResponse> {
    return this.http.post<UsuarioResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/usuario/incluir`, {usuario});
  }

    atualizar(usuario: Usuario): Observable<UsuarioResponse> {
      return this.http.post<UsuarioResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/usuario/atualizar`, {
        usuario
      });
    }

    deletar(usuario: Usuario): Observable<UsuarioResponse> {
     return this.http.post<UsuarioResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/usuario/excluir`, {
        usuario
      });
    }

    reenvioSenha(usuario: Usuario): Observable<UsuarioResponse> {
      return this.http.post<UsuarioResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/usuario/reenviosenha`, {
        usuario
      });
    }

    resetSenha(usuario: Usuario): Observable<UsuarioResponse> {
      return this.http.post<UsuarioResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/usuario/resetsenha`, {
          usuario
        });
    }

    handleError<T>(operation = 'operation', result?: T) {
      return (error: any): Observable<T> => {
        // TODO: send the error to remote logging infrastructure
        console.error(error); // log to console instead

        // TODO: better job of transforming error for user consumption
        console.log(`${operation} failed: ${error.message}`);

        // Let the app keep running by returning an empty result.
        return of(result as T);
      };
    }

    }
